var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"ma-0 pa-0",staticStyle:{"border-radius":"0","min-width":"100%","height":"45px"},attrs:{"depressed":"","color":"grey lighten-3"},on:{"click":function($event){return _vm.$emit('onsearch')}}},[_c('span',[_c('v-icon',{attrs:{"small":""}},[_vm._v("search")]),_vm._v(" "+_vm._s(_vm.$t('Search'))+" ")],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a78e1f32","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/livechat/LivechatSearchBox.vue
// module id = null
// module chunks = 